import {Game} from './game';
new Game();